import React from 'react';
import { observer } from 'mobx-react';
import dashboardSettingsStore from '../../../../../stores/dashboard-settings-store';
import AppHeaderNotificationLink, { NOTIFICATION_LINK_TYPE } from './app-header-notification-link';
import useDashboardTranslation from '../../../../../dashboard-translation/hooks/dashboard-translation-hook';

const HeaderNotifications: React.FC = observer(() => {
    if (!dashboardSettingsStore.scopeChangeUrl && !dashboardSettingsStore.acceptNewPlanUrl) {
        return null;
    }

    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-top-bar';

    return (
        <div className="header-notifications">
            {!!dashboardSettingsStore.scopeChangeUrl && (
                <AppHeaderNotificationLink
                    type={NOTIFICATION_LINK_TYPE.WARNING}
                    href={dashboardSettingsStore.scopeChangeUrl}
                    text={getTranslation('APPROVE_PERMISSIONS', scope)}
                />
            )}
            {!!dashboardSettingsStore.acceptNewPlanUrl && (
                <AppHeaderNotificationLink
                    type={NOTIFICATION_LINK_TYPE.INFO}
                    href={dashboardSettingsStore.acceptNewPlanUrl!}
                    text={getTranslation('ACCEPT_NEW_PLAN_BUTTON', scope)}
                />
            )}
        </div>
    );
});

export default HeaderNotifications;
